import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Text,
  Divider,
  Box,
  Flex,
  Checkbox
} from '@chakra-ui/react';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

const GameMarqueeModal = ({ isOpen, onClose, marquees }) => {
  const { t } = useTranslation();
  const [dontShowAgain, setDontShowAgain] = useState(false);

  const handleClose = () => {
    if (dontShowAgain) {
      marquees.forEach((item) => {
        // 設定 30 分鐘後過期 (30 / 1440 天)
        // 根據文件使用 hide_game_marquee_{id}
        Cookies.set(`hide_game_marquee_${item.marquee_id}`, 'true', {
          expires: 30 / 1440
        });
      });
    }
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size="sm">
      <ModalOverlay />
      <ModalContent bg="gamebox.base" color="white" mx={4}>
        <ModalHeader fontSize="lg" textAlign="center">
          {t('common.遊戲公告')}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Splide
            options={{
              // type: "loop",
              focus: 'center',
              perMove: 1,
              autoplay: true,
              arrows: false,
              pagination: true
            }}
          >
            {marquees.map((item) => (
              <SplideSlide key={item.marquee_id}>
                <Flex direction="column" align="center" minH="150px" pt={2}>
                  <Text
                    fontWeight="bold"
                    fontSize="lg"
                    mb={2}
                    textAlign="center"
                  >
                    {item.title}
                  </Text>
                  <Divider mb={4} />
                  <Box w="full" px={4}>
                    <Text
                      fontSize="sm"
                      whiteSpace="pre-wrap"
                      textAlign="left"
                      lineHeight="tall"
                    >
                      {item.content}
                    </Text>
                  </Box>
                </Flex>
              </SplideSlide>
            ))}
          </Splide>

          <Flex justify="flex-end" mt={4}>
            <Checkbox
              colorScheme="yellow"
              isChecked={dontShowAgain}
              onChange={(e) => setDontShowAgain(e.target.checked)}
            >
              <Text fontSize="xs">{t('common.noShow')}</Text>
            </Checkbox>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default GameMarqueeModal;
